import axios from 'axios';

export const overview = () =>
  axios
    .post('/api/overview')
    .then((response) => response.data)
    .catch((error) => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/homepage/_api.js